module.exports = __webpack_public_path__ + "static/media/passlogin.e654b78b.png";